function Partners() {
    const logos = ["DEMO/logos/blockpit.png", "DEMO/logos/blockpit.png", "DEMO/logos/blockpit.png", "DEMO/logos/blockpit.png", "DEMO/logos/blockpit.png"];

    return(
        <div className="my-16">
            <p className="text-slate-400 font-medium">
                Strong partnerships
            </p>
            <div className="flex flex-row flex-wrap justify-center">
                {logos.map((logo, i) => (
                    <img src={logo} alt="logo" height="45px" className="m-6 object-contain" key={"pressLogo-" + i} />
                ))}
            </div>
        </div>
    )
}

export default Partners;